import { render, staticRenderFns } from "./WagePaymentSystem.vue?vue&type=template&id=a2e30af2&scoped=true"
import script from "./WagePaymentSystem.vue?vue&type=script&lang=js"
export * from "./WagePaymentSystem.vue?vue&type=script&lang=js"
import style0 from "./WagePaymentSystem.vue?vue&type=style&index=0&id=a2e30af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e30af2",
  null
  
)

export default component.exports